import { motion } from "framer-motion";
import { STEPS } from "../content/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Process = () => (
  <section id="how-it-works" data-testid="process-section" className="relative py-24 lg:py-32 bg-[#F8FAFC] text-neutral-900 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading light
          overline="How it works"
          title="From idea to launched — in four simple steps."
          sub="A clear, straightforward process. You always know what's happening and what comes next."
        />
      </Reveal>
      <div className="mt-20 relative">
        <div className="hidden lg:block absolute top-7 left-0 right-0 h-px bg-neutral-200" aria-hidden="true" />
        <motion.div
          className="hidden lg:block absolute top-7 left-0 h-px bg-[#0055FF] origin-left"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.6, ease: "easeInOut" }}
          style={{ right: 0 }}
          aria-hidden="true"
        />
        <div className="grid lg:grid-cols-4 gap-12 lg:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={0.15 * i}>
              <div className="relative" data-testid={`process-step-${s.num}`}>
                <div className="flex items-center gap-4 lg:block">
                  <div className="relative z-10 w-14 h-14 rounded-2xl bg-white border border-neutral-200 shadow-sm flex items-center justify-center font-mono2 font-semibold text-[#0055FF]">
                    {s.num}
                    <span className="absolute -right-1 -top-1 w-3 h-3 rounded-full bg-cyan-400 border-2 border-[#F8FAFC]" aria-hidden="true" />
                  </div>
                  <h3 className="lg:mt-6 font-display text-xl font-bold tracking-tight">{s.title}</h3>
                </div>
                <p className="mt-3 text-sm text-neutral-600 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
